import React, { Component } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import { setPymeValue } from "../../../actions";
import pymeImage from '../../../assets/pyme/pyme.png';
import { pyme } from "../../../operations";
import Continue from "../../Common/Continue";
import Loader from '../../Common/Loader';
import { numberWithDots } from "../../../helpers";
import Text from '../../Common/Form/Text';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class CoverageModules extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getModules = this.getModules.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidMount() {
    const { getCoverageModules } = this.props;
    this.checkContinueState(null);
    getCoverageModules();
  }
  
  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {
    const { 
      coverageModule, 
      coverageModules 
    } = this.props;
    return ( 
      coverageModules != null &&
      coverageModules.length > 0 &&
      coverageModule
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  handleOnClick(key) {
    const { onValueChange } = this.props;
    return () => onValueChange('coverageModule', key);
  }

  getModules() {
    const { coverageModule, coverageModules, coveragePlan, coveragePlans } = this.props;    
    const selectedPlan = coveragePlans.find((p) => p.clave == coveragePlan );
    
    const modules = coverageModules.map((e)=> {
      return {
        key: e.codigoModulo, title: e.descripcion,
        amount: e.monto, coverages: e.coberturas,
        selected: e.codigoModulo == coverageModule,
        selectedPlan, onChange: this.handleOnClick(e.codigoModulo),
      };
    });

    const selectedIndex = modules.findIndex((p) => p.selected);
    const selected = modules[selectedIndex];
    const moduleHeaders = modules.map((e)=> { return (<CoverageModule key={e.key} {...e} />) });
    const modulesSlider = modules.map((e)=> { return (<CoverageModuleInfoSlider key={e.key} {...e} />) });
    
    var sliderSettings = {
      dots: true, slidesToShow: 1,
      arrows: false, slidesToScroll: 1,
      centerMode: true, centerPadding: "40px",
      infinite: false, initialSlide: selectedIndex,
      afterChange: current => this.handleOnClick(coverageModules[current].codigoModulo)(),
    };

    return (
      <div className="coverage-modules-container">
        <div className="coverage-modules">
          <div className="coverage-modules-headers">{moduleHeaders}</div>
          <div ref="CoverageModule" className="coverage-module">
            <div className="coverage-module-img"> <img src={pymeImage}/> </div>
            <div> <CoverageModuleInfo {...selected} /> </div>
          </div>
        </div>
        <div className="coverage-modules-slider">
          <Slider ref={slider => (this.slider = slider)} {...sliderSettings}> {modulesSlider} </Slider>
        </div>
      </div>
    );
  }

  render() {
    const { continue: toContinue } = this.state;
    const { 
      innerLoading, coverageModules, getQuotation 
    } = this.props;
    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          Te ofrecemos 4 módulos para proteger tu empresa, elegí el que se ajusta de la mejor manera a tus prioridades
        </Text>
        {innerLoading ? <Loader message='' /> :
        <div>
          { coverageModules != null &&
            coverageModules.length > 1 && 
            this.getModules() }
          <Continue state={toContinue} onClick={getQuotation} />
        </div>}
      </div>
    );
  }
}

const setPrefiOrSuffix = ({idCobertura, capital}) => {
  if(idCobertura == 9 && capital <= 100) return capital + " %";
  else return "USD " + numberWithDots(capital);
};

const CoverageModule = ({  title, selected, onChange }) => {
  const selectedClass = selected ? "coverage-module-selected" : "";
  return (
  <div className={`coverage-module-title ${selectedClass}`} onClick={onChange}>
    {title}
  </div>
)};

const CoverageModuleInfoRow = ({ text, value }) => (<div className="coverage-module-row"><div>{text}</div><div>{value}</div></div>)

const CoverageModuleInfo = ({  selectedPlan, coverages }) => {
  const { valor } = selectedPlan;
  const splitPoint = valor.indexOf(" USD ");
  const amount = valor.slice(splitPoint + 1, valor.length);
  const covers = coverages.map((c) => (<CoverageModuleInfoRow key={c.idCobertura} text={c.descripcion} value={setPrefiOrSuffix(c)} />));
  return (
  <div>
    <div className="coverage-module-coverages coverage-module-animate" >
      <CoverageModuleInfoRow text="Robo" value={amount} /> 
      {covers} 
    </div>
  </div>
)};

const CoverageModuleInfoSlider = ({ title, selectedPlan, coverages, selected, className = "" }) => {
  const selectedClass = selected? "coverage-module-selected": "";
  return (
  <div className={`coverage-module  ${className}`}>
    <div className={`coverage-module-title ${selectedClass}`}> {title} </div>
    <CoverageModuleInfo selectedPlan={selectedPlan} coverages={coverages} />
  </div>
)};

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,
    innerLoading: state.steps.isInnerLoading,

    coveragePlan: state.pyme.coveragePlan,
    coveragePlans: state.pyme.coveragePlans,
    coverageModule: state.pyme.coverageModule,
    coverageModules: state.pyme.coverageModules,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCoverageModules: () => {
      dispatch(pyme.getCoverageModules());
    },
    onValueChange: (type, value) => {
      dispatch(setPymeValue(type, value));
    },
    getQuotation: () => {
      dispatch(pyme.getQuotation());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoverageModules);